export default __webpack_public_path__ + "static/media/rpsGame_blog.497dbd85.jfif";